<template>
	<div>
      <v-container grid-list-xl>        
        <v-flex xs3>
          <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />
        </v-flex>
        <v-data-table loading="true" :headers="headers" :items="overrideSettings" :search="search" hide-actions disable-initial-sort class="elevation-1">
          <template slot="items" slot-scope="props">            
              <td width="10%"><v-switch v-model="props.item.override" @click="fncSaveOverride(props.item.id, props.item.override)"></v-switch></td>              
              <td width="90%">{{ props.item.fullname }}</td>                          
          </template>
        </v-data-table>
        <v-layout row wrap class="pl-4 pr-4 pt-4 pb-4">
          <div class="pl-4 pr-1 pb-2 buttonHolder">
            <div style="float: right">
              <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>              
            </div>
          </div>
        </v-layout>
      </v-container>	
      </div>
</template>

<script>

	import { mapGetters } from 'vuex';
    
	export default {
        name: 'UserNotifications',
        components: {},
		data () {
          return {	
              search: '',
              currentUserCompany: this.$store.getters.currentUserCompany,
              headers: [
                { text: 'Override', value: '', width: '10%' },
                { text: 'Name', value: 'fullname', width: '90%' }                
              ]	
			}
		},
		methods: {
            fncHideModal () {
                this.$store.commit('hideModal');
            },            
            fncSaveOverride(userId, override) {
              var overrideType = 'remove';
              if (override == 0 || override == false ) {
                overrideType = 'add';
              }              
              this.$store.dispatch({
                type: 'fncSaveOverrideSettings',
                userId: userId,
                override: overrideType
              })              
            }
		},
		computed: {
			...mapGetters([
                'objAuthorize',
                'globalModalParams',
                'overrideSettings'                
			])
        }
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css';
</style>